var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBattleRifle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.609 28.9559C117.911 28.4174 117.308 26.4539 116.876 25.3139C116.444 24.1739 115.625 24.0599 114.788 23.7719C113.951 23.4839 113.816 24.5114 113.816 24.5114L104.807 24.1739L103.202 23.5829L93.1505 23.7524L87.914 25.1879L71.021 25.0184V22.9349L69.839 22.2314L68.5715 22.3154L67.811 21.5549V20.6264L65.4455 18.8519H63.419V15.6419L61.814 15.4724L59.507 14.3009L57.9275 13.0289L57.758 11.1659H56.153V17.0789L57.758 18.2609H31.4045L28.1945 19.6964L23.8865 19.7189L21.068 20.3279L16.454 22.9334L16.1165 27.3824L7.24698 27.3914L6.65598 26.6849C6.65598 26.6849 1.33398 27.1289 1.33398 26.5364V30.4784H6.73998L7.47198 29.9999L13.553 30.1604V31.6049L13.898 32.4914L13.6655 33.4064V35.4329L17.5505 35.5169L19.127 35.9954L22.8155 35.9564L23.252 37.2194L27.638 38.5484L54.062 38.7824L55.3925 38.1914L57.377 38.1494L58.7285 36.7139H64.1345L64.295 37.9574L65.135 39.5489L70.5815 39.7574L71.0615 40.5989C71.0615 40.5989 72.1595 41.9504 72.539 42.6689C72.9185 43.3874 72.3275 43.8509 72.878 44.7989C73.4285 45.7469 74.168 46.6934 74.396 47.7374C74.624 48.7814 75.3245 49.1729 75.3245 49.1729H79.886C79.886 49.1729 80.534 48.6299 80.9225 47.2964C81.3095 45.9629 80.759 44.2139 80.309 43.1264C79.859 42.0389 77.4365 39.7124 77.4365 39.7124C77.4365 39.7124 76.643 38.8574 76.3505 37.9574C76.0595 37.0589 77.327 35.6294 78.1985 35.3384C79.07 35.0474 80.561 35.7419 80.561 35.7419L83.4335 35.8124L84.308 36.2204L87.7415 41.3804L88.6595 42.6389L90.4025 45.1739C90.4025 45.1739 91.925 46.5524 93.317 47.0459C94.709 47.5394 96.443 47.1449 96.443 47.1449L105.414 46.0154L110.718 45.2024C110.718 45.2024 113.76 43.2254 115.335 42.0404C116.91 40.8569 116.63 38.6144 116.63 38.6144C116.63 38.6144 116.546 31.8569 116.582 31.0004C116.619 30.1439 117.305 29.4914 117.606 28.9529L117.609 28.9559ZM60.461 25.3559H59.5055L55.3925 26.5379H43.5665L42.7775 26.8754H33.8795L32.585 26.5379H30.0515V24.3974L31.853 23.2709L58.967 22.9334L60.4595 24.2849V25.3544L60.461 25.3559ZM70.034 38.5334H66.74C66.74 38.5334 65.135 38.7584 65.135 37.6604V35.8589L66.8525 35.1554H68.852C68.852 35.1554 69.2465 35.9444 68.852 36.8159C68.4575 37.6874 67.94 37.8299 67.94 37.8299C67.94 37.8299 69.893 38.1674 70.5695 36.7604C70.5695 36.7604 70.7105 38.1959 70.034 38.5349V38.5334Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.704 37.9829C112.704 37.9829 113.802 37.7294 113.971 38.9114C114.141 40.0934 112.704 40.1789 112.704 40.1789V43.3469",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.635 25.6829V31.5779",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5342 25.7008V31.5778",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9903 31.1548V34.8988C40.9903 34.8988 40.7788 35.6593 42.5113 35.6593H55.1818",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.29 28.3108C32.416 28.3528 42.4255 28.3108 42.4255 28.3108L46.057 30.1603L55.5595 30.2068L56.446 29.2588H66.793L68.5675 28.6393H70.003V28.1008H77.605C77.605 28.1008 79.126 28.0588 79.168 28.7758H84.3205C84.3205 28.7758 85.672 28.8598 85.714 27.9733C85.756 27.0868 84.2365 27.1498 84.2365 27.1498H80.3515L80.3095 26.6848H54.715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0789 19.8224H33.4724L34.1489 20.2439H60.2909V22.1279H60.9674L62.1929 24.0884V26.6849",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9453 32.7463V35.6593",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8164 34.6888V35.6593",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6389 35.2798V38.5513",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.13599 27.8669H5.04899",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.13599 29.3879H5.04899",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91602 26.5378V30.2068",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24609 27.2759V30.1604",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4707 27.6779V29.7044",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0264 27.6779V29.9999",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8975 27.6779V29.8949",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2627 25.3544V31.4159",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8145 26.7689H23.886V31.1399",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0527 26.5378V31.0138",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6151 28.1849C45.7087 28.1849 45.7846 28.109 45.7846 28.0154C45.7846 27.9218 45.7087 27.8459 45.6151 27.8459C45.5214 27.8459 45.4456 27.9218 45.4456 28.0154C45.4456 28.109 45.5214 28.1849 45.6151 28.1849Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9664 28.1849C47.06 28.1849 47.1359 28.109 47.1359 28.0154C47.1359 27.9218 47.06 27.8459 46.9664 27.8459C46.8728 27.8459 46.7969 27.9218 46.7969 28.0154C46.7969 28.109 46.8728 28.1849 46.9664 28.1849Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3179 28.1849C48.4116 28.1849 48.4874 28.109 48.4874 28.0154C48.4874 27.9218 48.4116 27.8459 48.3179 27.8459C48.2243 27.8459 48.1484 27.9218 48.1484 28.0154C48.1484 28.109 48.2243 28.1849 48.3179 28.1849Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6693 28.1849C49.7629 28.1849 49.8388 28.109 49.8388 28.0154C49.8388 27.9218 49.7629 27.8459 49.6693 27.8459C49.5756 27.8459 49.4998 27.9218 49.4998 28.0154C49.4998 28.109 49.5756 28.1849 49.6693 28.1849Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0211 28.1849C51.1147 28.1849 51.1906 28.109 51.1906 28.0154C51.1906 27.9218 51.1147 27.8459 51.0211 27.8459C50.9275 27.8459 50.8516 27.9218 50.8516 28.0154C50.8516 28.109 50.9275 28.1849 51.0211 28.1849Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3724 28.1849C52.466 28.1849 52.5419 28.109 52.5419 28.0154C52.5419 27.9218 52.466 27.8459 52.3724 27.8459C52.2788 27.8459 52.2029 27.9218 52.2029 28.0154C52.2029 28.109 52.2788 28.1849 52.3724 28.1849Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7242 28.1848C53.8178 28.1848 53.8937 28.1089 53.8937 28.0153C53.8937 27.9217 53.8178 27.8458 53.7242 27.8458C53.6306 27.8458 53.5547 27.9217 53.5547 28.0153C53.5547 28.1089 53.6306 28.1848 53.7242 28.1848Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0758 28.1848C55.1694 28.1848 55.2452 28.1089 55.2452 28.0153C55.2452 27.9217 55.1694 27.8458 55.0758 27.8458C54.9821 27.8458 54.9062 27.9217 54.9062 28.0153C54.9062 28.1089 54.9821 28.1848 55.0758 28.1848Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1929 21.3013C62.2866 21.3013 62.3624 21.2255 62.3624 21.1318C62.3624 21.0382 62.2866 20.9623 62.1929 20.9623C62.0993 20.9623 62.0234 21.0382 62.0234 21.1318C62.0234 21.2255 62.0993 21.3013 62.1929 21.3013Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5865 25.4114C63.6801 25.4114 63.756 25.3355 63.756 25.2419C63.756 25.1483 63.6801 25.0724 63.5865 25.0724C63.4929 25.0724 63.417 25.1483 63.417 25.2419C63.417 25.3355 63.4929 25.4114 63.5865 25.4114Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6422 17.2034C61.7358 17.2034 61.8117 17.1275 61.8117 17.0339C61.8117 16.9403 61.7358 16.8644 61.6422 16.8644C61.5485 16.8644 61.4727 16.9403 61.4727 17.0339C61.4727 17.1275 61.5485 17.2034 61.6422 17.2034Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7574 15.1348C57.851 15.1348 57.9269 15.0589 57.9269 14.9653C57.9269 14.8717 57.851 14.7958 57.7574 14.7958C57.6638 14.7958 57.5879 14.8717 57.5879 14.9653C57.5879 15.0589 57.6638 15.1348 57.7574 15.1348Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3004 32.9159C42.394 32.9159 42.4699 32.84 42.4699 32.7464C42.4699 32.6528 42.394 32.5769 42.3004 32.5769C42.2067 32.5769 42.1309 32.6528 42.1309 32.7464C42.1309 32.84 42.2067 32.9159 42.3004 32.9159Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2327 32.8303C34.3263 32.8303 34.4022 32.7544 34.4022 32.6608C34.4022 32.5672 34.3263 32.4913 34.2327 32.4913C34.1391 32.4913 34.0632 32.5672 34.0632 32.6608C34.0632 32.7544 34.1391 32.8303 34.2327 32.8303Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2447 32.7463C24.3383 32.7463 24.4142 32.6705 24.4142 32.5768C24.4142 32.4832 24.3383 32.4073 24.2447 32.4073C24.1511 32.4073 24.0752 32.4832 24.0752 32.5768C24.0752 32.6705 24.1511 32.7463 24.2447 32.7463Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8931 37.0844C53.9867 37.0844 54.0626 37.0085 54.0626 36.9149C54.0626 36.8212 53.9867 36.7454 53.8931 36.7454C53.7995 36.7454 53.7236 36.8212 53.7236 36.9149C53.7236 37.0085 53.7995 37.0844 53.8931 37.0844Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8568 25.2434C67.9504 25.2434 68.0263 25.1675 68.0263 25.0739C68.0263 24.9802 67.9504 24.9044 67.8568 24.9044C67.7631 24.9044 67.6873 24.9802 67.6873 25.0739C67.6873 25.1675 67.7631 25.2434 67.8568 25.2434Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3082 33.6328C86.4018 33.6328 86.4777 33.5569 86.4777 33.4633C86.4777 33.3697 86.4018 33.2938 86.3082 33.2938C86.2146 33.2938 86.1387 33.3697 86.1387 33.4633C86.1387 33.5569 86.2146 33.6328 86.3082 33.6328Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3083 34.8988C87.1011 34.8988 87.7438 34.2561 87.7438 33.4633C87.7438 32.6705 87.1011 32.0278 86.3083 32.0278C85.5155 32.0278 84.8728 32.6705 84.8728 33.4633C84.8728 34.2561 85.5155 34.8988 86.3083 34.8988Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8514 29.9999C68.945 29.9999 69.0209 29.924 69.0209 29.8304C69.0209 29.7368 68.945 29.6609 68.8514 29.6609C68.7578 29.6609 68.6819 29.7368 68.6819 29.8304C68.6819 29.924 68.7578 29.9999 68.8514 29.9999Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M110.916 28.0154C111.009 28.0154 111.085 27.9395 111.085 27.8459C111.085 27.7523 111.009 27.6764 110.916 27.6764C110.822 27.6764 110.746 27.7523 110.746 27.8459C110.746 27.9395 110.822 28.0154 110.916 28.0154Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M113.985 41.3834C114.079 41.3834 114.154 41.3075 114.154 41.2139C114.154 41.1203 114.079 41.0444 113.985 41.0444C113.891 41.0444 113.815 41.1203 113.815 41.2139C113.815 41.3075 113.891 41.3834 113.985 41.3834Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M110.579 33.6328C110.672 33.6328 110.748 33.5569 110.748 33.4633C110.748 33.3697 110.672 33.2938 110.579 33.2938C110.485 33.2938 110.409 33.3697 110.409 33.4633C110.409 33.5569 110.485 33.6328 110.579 33.6328Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M114.957 25.4818C115.05 25.4818 115.126 25.4059 115.126 25.3123C115.126 25.2187 115.05 25.1428 114.957 25.1428C114.863 25.1428 114.787 25.2187 114.787 25.3123C114.787 25.4059 114.863 25.4818 114.957 25.4818Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2493 29.2933C46.3429 29.2933 46.4188 29.2175 46.4188 29.1238C46.4188 29.0302 46.3429 28.9543 46.2493 28.9543C46.1557 28.9543 46.0798 29.0302 46.0798 29.1238C46.0798 29.2175 46.1557 29.2933 46.2493 29.2933Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6011 29.2933C47.6948 29.2933 47.7706 29.2175 47.7706 29.1238C47.7706 29.0302 47.6948 28.9543 47.6011 28.9543C47.5075 28.9543 47.4316 29.0302 47.4316 29.1238C47.4316 29.2175 47.5075 29.2933 47.6011 29.2933Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9527 29.2933C49.0463 29.2933 49.1222 29.2175 49.1222 29.1238C49.1222 29.0302 49.0463 28.9543 48.9527 28.9543C48.8591 28.9543 48.7832 29.0302 48.7832 29.1238C48.7832 29.2175 48.8591 29.2933 48.9527 29.2933Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3043 29.2933C50.3979 29.2933 50.4738 29.2175 50.4738 29.1238C50.4738 29.0302 50.3979 28.9543 50.3043 28.9543C50.2106 28.9543 50.1348 29.0302 50.1348 29.1238C50.1348 29.2175 50.2106 29.2933 50.3043 29.2933Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6558 29.2933C51.7494 29.2933 51.8253 29.2175 51.8253 29.1238C51.8253 29.0302 51.7494 28.9543 51.6558 28.9543C51.5622 28.9543 51.4863 29.0302 51.4863 29.1238C51.4863 29.2175 51.5622 29.2933 51.6558 29.2933Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0064 29.2933C53.1 29.2933 53.1759 29.2175 53.1759 29.1238C53.1759 29.0302 53.1 28.9543 53.0064 28.9543C52.9128 28.9543 52.8369 29.0302 52.8369 29.1238C52.8369 29.2175 52.9128 29.2933 53.0064 29.2933Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M54.359 29.2933C54.4526 29.2933 54.5285 29.2175 54.5285 29.1238C54.5285 29.0302 54.4526 28.9543 54.359 28.9543C54.2653 28.9543 54.1895 29.0302 54.1895 29.1238C54.1895 29.2175 54.2653 29.2933 54.359 29.2933Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0218 29.1659H35.8693C35.5951 29.1659 35.3728 29.3882 35.3728 29.6624C35.3728 29.9366 35.5951 30.1589 35.8693 30.1589H41.0218C41.296 30.1589 41.5183 29.9366 41.5183 29.6624C41.5183 29.3882 41.296 29.1659 41.0218 29.1659Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6055 21.3208L23.2315 22.6303",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2637 21.1364L24.8897 22.4459",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2393 21.1364L26.8653 22.4459",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4062 15.9794H58.5467L60.1518 16.8659H61.6428",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3843 26.5379L71.5543 25.4114H69.1603V24.5939L68.0263 23.6939H67.1623L63.4168 19.8224H60.3193",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4053 38.7854H93.9108",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M110.598 35.6594H105.477C105.083 35.6594 104.764 35.9784 104.764 36.3719C104.764 36.7654 105.083 37.0844 105.477 37.0844H110.598C110.991 37.0844 111.31 36.7654 111.31 36.3719C111.31 35.9784 110.991 35.6594 110.598 35.6594Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M101.314 29.1659H110.578C110.578 29.1659 111.987 29.2139 111.987 28.4459V26.8754L113.346 26.1569L111.987 26.8754H80.3113",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3184 24.9044H97.2889",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4895 34.2809V36.2234H89.0955L90.222 34.2809H88.4895Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5613 30.2068L54.0613 32.0278",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9072 31.0018H64.2897L66.3162 29.2589",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 26.5379H7.24698V27.3929H16.454V22.9349L20.5085 20.6264C20.5085 20.6264 21.776 19.6979 24.647 19.6979H28.1945L30.8135 18.2624H57.7595L56.1545 17.0804V11.1674H57.7595C57.7595 11.1674 57.59 12.8564 58.1825 13.4474C58.7735 14.0384 61.814 15.4739 61.814 15.4739L63.419 15.6434V18.8534H65.4455L67.811 20.6279V21.5564L68.5715 22.3169L69.839 22.2329L71.021 22.9364V25.0199L87.914 25.1894L93.1505 23.7539L103.202 23.5844L104.807 24.1754L113.507 24.0914C113.507 24.0914 114.521 23.5004 115.365 23.9219C116.21 24.3434 116.922 24.9359 117.308 26.4554C117.693 27.9749 117.899 28.8209 117.308 29.4959C116.717 30.1709 116.547 30.5099 116.547 31.8614C116.547 33.2129 116.631 38.6189 116.631 38.6189C116.631 38.6189 117.054 40.6454 115.196 42.1664C113.337 43.6874 110.888 44.9534 110.718 45.2069C110.549 45.4604 107.846 45.7139 107.846 45.7139L96.443 47.1494C96.443 47.1494 92.3885 47.8244 90.614 45.4604L88.8395 43.0949L88.3325 41.8274L84.0245 35.8304L80.561 35.7464C80.561 35.7464 77.5205 34.4789 76.76 36.3374C75.9995 38.1959 76.337 38.7029 77.435 39.7154C78.533 40.7294 80.8985 42.8414 80.9825 45.5444C81.0665 48.2474 80.4755 49.0079 79.8845 49.1759C79.2935 49.3454 75.323 49.1759 75.323 49.1759C75.323 49.1759 74.4365 48.6269 74.3945 47.7404C74.3525 46.8539 73.8035 45.7559 73.3805 45.3329C72.9575 44.9099 72.452 44.4044 72.3245 43.8554C72.197 43.3064 72.704 42.6734 72.155 41.9549C71.606 41.2364 71.057 40.6034 71.057 40.6034L71.015 39.7589L65.8625 39.8009C65.8625 39.8009 64.7645 39.7169 64.469 38.7029C64.1735 37.6889 64.1315 36.7184 64.1315 36.7184H58.7255L57.374 38.1539L55.3895 38.1959L54.488 38.8154L28.022 38.7449L23.249 37.2239L23.123 35.9564L19.1255 35.9984L18.056 35.3789L13.664 35.4359L13.721 32.7329L14.3405 32.3954L13.5515 31.6064L13.4945 30.8174L14.0015 29.9999H7.47198V30.4784H1.33398V26.5364V26.5379Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0527 26.5379V24.3974L31.8542 23.2709L58.9682 22.9334L60.4607 24.2849V25.3544H59.5052L55.3922 26.5379H43.5677L42.7787 26.8754H33.8822L32.5862 26.5379H30.0527Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8525 35.1524H68.852C68.852 35.1524 69.2465 35.9414 68.852 36.8129C68.4575 37.6859 67.94 37.8269 67.94 37.8269C67.94 37.8269 69.893 38.1644 70.5695 36.7574C70.5695 36.7574 70.7105 38.1929 70.034 38.5319H66.74C66.74 38.5319 65.135 38.7569 65.135 37.6589V35.8574L66.8525 35.1539V35.1524Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M113.507 24.0884V25.9469L115.112 27.5939C115.112 27.5939 115.619 28.1009 115.112 28.5659C114.605 29.0309 113.719 28.8614 113.719 28.8614C113.719 28.8614 113.677 30.1709 113.719 30.8039C113.761 31.4369 113.086 32.7464 113.128 33.3809V36.5069C113.128 36.5069 113.381 37.4789 112.705 37.9844C112.028 38.4899 111.691 38.5529 111.691 38.5529H110.804L108.271 40.3499C108.271 40.3499 107.68 40.7294 107.68 41.7854C107.68 42.3134 107.722 43.2959 107.764 44.1449C107.806 44.9954 107.848 45.7124 107.848 45.7124",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M107.763 44.1434L95.853 45.4574L94.6275 44.8004H90.123",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4902 42.2114H107.678",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M100.668 27.4094H89.0119C89.0119 27.4094 87.9979 27.3809 87.9424 28.0004C87.8869 28.6199 87.9424 28.9019 87.9424 28.9019C87.9424 28.9019 87.8299 29.2109 88.6744 29.8304C89.5189 30.4499 90.0829 30.8159 90.0829 30.8159C90.0829 30.8159 90.2524 31.0979 91.7434 31.1249C93.2359 31.1534 94.5034 31.1249 94.5034 31.1249V30.7019H97.0654V31.1369H100.388C100.388 31.1369 101.316 31.1804 101.316 30.5894V27.4079H100.668V27.4094Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3006 21.8819V24.0029C18.3006 24.0029 17.9736 25.7339 19.2411 25.6919C20.5086 25.6499 21.7746 25.6919 21.7746 25.6919C21.7746 25.6919 23.0001 25.8599 23.0001 24.6359L24.0141 23.4539L29.0406 23.4119L30.8151 22.1024L31.9131 21.8819V18.5549",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4539 27.3914V31.5779H22.8169V32.9294H16.4539V31.5779",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8174 31.578L23.9709 31.155H42.5544L44.5254 32.4225H55.3659V37.8555",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3652 32.4225H72.2012L73.1867 31.4925H78.3392L78.9587 31.14H81.1832L81.8672 31.8225H84.1397L89.7707 40.0515H97.2467L98.9432 40.9395H100.203V42.2115",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7581 18.2594H63.4176",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8154 23.6655V31.14",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0791 26.8754V31.1399",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8174 32.9294V34.5059L28.9554 35.4914L29.5464 36.1244V38.7464",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattleRifle);
export default __webpack_public_path__ + "static/media/Battle Rifle.416011c2ef11ca44dda7ff6fc85ac01b.svg";
export { ForwardRef as ReactComponent };